import { AudioManager } from './audio.js';

export class SoundController {
  constructor(store) {
    this.store = store;
    this.audio = new AudioManager();
    this.muteButton = null;
    this.prevMuted = null;
    this.prevPhase = null;
    this.prevGemsMerged = 0;
    this.prevWave = 0;
    
    // Initialize audio on first user gesture
    this.audio.init();
  }
  
  init() {
    this.muteButton = document.getElementById('mute-button');
    if (this.muteButton) {
      this.updateMuteButton();
      this.muteButton.addEventListener('click', () => this.toggleMute());
      
      // Resume audio context on first interaction with mute button
      this.muteButton.addEventListener('pointerdown', () => {
        this.audio.resume();
      });
    }
    
    // Also resume on any game start click (start button)
    const startBtn = document.getElementById('start-btn');
    if (startBtn) {
      startBtn.addEventListener('pointerdown', () => {
        this.audio.resume();
      });
    }
    
    // Subscribe to store changes
    this.store.subscribe((state, prevState) => {
      this.handleStoreChange(state, prevState);
    });
  }
  
  toggleMute() {
    const muted = this.audio.toggleMute();
    this.updateMuteButton();
    // Play click sound (even when muting? maybe not)
    if (!muted) {
      this.audio.playClick();
    }
    return muted;
  }
  
  updateMuteButton() {
    if (!this.muteButton) return;
    const muted = this.audio.muted;
    if (this.prevMuted === muted) return;
    this.prevMuted = muted;
    this.muteButton.classList.toggle('muted', muted);
    this.muteButton.querySelector('.mute-icon').textContent = muted ? '🔇' : '🔊';
    this.muteButton.setAttribute('aria-label', muted ? 'Unmute sound' : 'Mute sound');
  }
  
  handleStoreChange(state, prevState) {
    // Phase changes
    if (state.phase !== prevState.phase) {
      if (state.phase === 'victory') {
        this.audio.playVictory();
      } else if (state.phase === 'gameover') {
        this.audio.playGameOver();
      }
    }
    
    // Gem merged
    if (state.gemsMerged > prevState.gemsMerged) {
      // Find which gem tier was merged (simplify: assume tier increase)
      // We could track last merged gem but for simplicity play tier 2 sound if highest tier increased
      const tier = Math.min(state.highestTierReached, 3);
      this.audio.playMerge(tier);
    }
    
    // Wave started
    if (state.currentWave > prevState.currentWave) {
      this.audio.playWaveStart();
    }
    
    // Update mute button if needed
    this.updateMuteButton();
  }
  
  // Called from UI controller when purchase happens (since purchaseGem doesn't have a store subscription)
  onPurchaseGem() {
    this.audio.playPurchase();
  }
}